export interface Workspace {
  id: string;
  account: string;
  app: string;
  name: string;
  isolationMode: string;
  schemaName: string | null;
  isDefault: boolean;
  archived: boolean;
  memberCount?: number;
  createdOn?: string;
  createdBy?: string;
  updatedOn?: string;
  updatedBy?: string;
}

/** ApiResponse envelope returned by add/update/archive endpoints. */
export interface WorkspaceApiResponse {
  code: number;
  message: string; // for `add`, this is the new workspace id
}

export interface WorkspaceRole {
  id: number;
  account: string | null;
  name: string;
  preset: boolean;
  permissionsJson: string; // stringified JSON array — what add/update send
  permissions?: string[]; // derived array returned in responses
  createdOn?: string;
  createdBy?: string;
}

export interface WorkspaceMembership {
  id: string;
  workspaceId: string;
  account: string;
  app: string;
  userEmail: string;
  roleId: number;
  createdOn?: string;
  createdBy?: string;
}

/** Per-workspace branding (mirrors the backend CustomBranding fields). */
export interface WorkspaceBranding {
  name?: string;
  appUrl?: string;
  senderEmail?: string;
  senderDisplayName?: string;
  logoUrl?: string;
  primaryColor?: string;
  footerHtml?: string;
  buttonTextColor?: string;
  enabled: boolean;
}

/**
 * A workspace's envelope quota for the current billing period (mirrors the backend WorkspaceQuota).
 * `quota` is absent when no quota is set. `eligible` is false on plans without quotas
 * (free, trial, lifetime). `periodEnd` is the period's last day.
 */
export interface WorkspaceQuota {
  workspaceId: string;
  quota?: number;
  periodStart?: string;
  periodEnd?: string;
  used: number;
  remaining?: number;
  percentUsed?: number;
  eligible: boolean;
  planLimit?: number;
  warning?: string;
}

/** The workspace-permission catalog (mirrors the backend WorkspacePermission constants). */
export const WORKSPACE_PERMISSIONS: { key: string; label: string }[] = [
  { key: "document.view.any", label: "View all documents" },
  { key: "document.view.own", label: "View own documents" },
  { key: "document.create", label: "Create documents" },
  { key: "document.send", label: "Send documents" },
  { key: "document.void", label: "Void documents" },
  { key: "document.download", label: "Download documents" },
  { key: "template.manage", label: "Manage templates" },
  { key: "member.manage", label: "Manage members" },
  { key: "workspace.settings", label: "Workspace settings" },
  { key: "role.manage", label: "Manage roles" },
  { key: "audit.view", label: "View audit trail" },
  { key: "report.view", label: "View reports" },
];
